import { makeStyles } from '@material-ui/core/styles';

const NAVY = '#01294B';

export const useStyles = makeStyles(theme => ({
  banner: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    // Fixed height + vertically centered content, so the banner stays the same
    // height whether or not a message has an action button.
    height: 48,
    boxSizing: 'border-box',
    padding: '0 56px',
    backgroundColor: NAVY,
    color: '#FFFFFF',
    [theme.breakpoints.down('sm')]: {
      gap: 8,
      padding: '0 40px'
    }
  },
  content: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16
  },
  message: {
    minWidth: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '0.01em',
    lineHeight: 1.4
  },
  navButton: {
    color: '#FFFFFF',
    padding: 4,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)'
    }
  },
  progressTrack: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: 3,
    backgroundColor: 'rgba(255, 255, 255, 0.15)'
  },
  progressBar: {
    height: '100%',
    width: '100%',
    backgroundColor: '#FFFFFF',
    transformOrigin: 'left center',
    animationName: '$bannerProgress',
    animationTimingFunction: 'linear',
    animationFillMode: 'forwards',
    animationIterationCount: 1,
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none'
    }
  },
  '@keyframes bannerProgress': {
    from: { transform: 'scaleX(0)' },
    to: { transform: 'scaleX(1)' }
  },
  actionButton: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
    backgroundColor: '#FFFFFF',
    color: NAVY,
    borderRadius: 99,
    fontWeight: 600,
    textTransform: 'none',
    minHeight: 24,
    lineHeight: 1.4,
    '&:hover': {
      backgroundColor: '#E6ECF2'
    }
  },
  closeButton: {
    position: 'absolute',
    right: 8,
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)'
    }
  },
  dialogPaper: {
    borderRadius: 16,
    maxWidth: 520,
    width: '100%'
  },
  dialogHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
    padding: '20px 20px 0 24px'
  },
  dialogTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: '#0F172A'
  },
  dialogBody: {
    padding: '8px 24px 16px',
    color: '#334155',
    fontSize: 14,
    lineHeight: 1.55,
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  dialogActions: {
    padding: '10px 24px',
    borderTop: '1px solid #E2E8F0',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8
  },
  dialogCloseIcon: {
    color: '#64748B'
  }
}));
